import { useNotification } from '@/hooks';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { getErrorMessage } from '@/utils/errorUtils';
import { toFullMobilePhone } from '@/utils/phoneNumber';
import { appUrl } from '@/utils/appUrl';
import { useNavigate } from 'react-router-dom';
import {
  useInviteUserMutation,
  useSendInvitationMutation,
} from '../services/users.service';
import { InviteUserSchema } from '../models';
import { buildScopesAndExclusionsFromAccess } from '../utils/inviteUserScopes';

const GENERIC_ERROR_MESSAGE =
  'Ocurrió un error al invitar el usuario. Inténtalo nuevamente.';

const useInviteUserActions = () => {
  const { showNotification } = useNotification();
  const navigate = useNavigate();
  const [inviteUser, { isLoading: isInviting }] = useInviteUserMutation();
  const [sendInvitation, { isLoading: isSendingInvitation }] =
    useSendInvitationMutation();

  const isInvitingUser = isInviting || isSendingInvitation;

  const onInviteUser = async (data: InviteUserSchema) => {
    const fullPhone = toFullMobilePhone(data.phone);
    const { scopes, exclusions } = buildScopesAndExclusionsFromAccess({
      operators: data.operators,
      commerces: data.commerces,
      branches: data.branches,
    });

    try {

      const result = await inviteUser({
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        phoneNumber: fullPhone,
        roleIds: data.roleIds,
        scopes,
        exclusions,
      }).unwrap();

      const userId = result.user.id;
      const invitationLink = appUrl(`/register/${userId}`);

      try {
        await sendInvitation({
          userId,
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          phoneNumber: fullPhone,
          invitationLink,
        }).unwrap();
      } catch (error) {
        showNotification(
          getErrorMessage(error, GENERIC_ERROR_MESSAGE),
          NotificationSeverity.error
        );
        return;
      }

      showNotification(
        'Usuario invitado correctamente',
        NotificationSeverity.success
      );
      navigate('/business/users');
    } catch (error) {
      showNotification(
        getErrorMessage(error, GENERIC_ERROR_MESSAGE),
        NotificationSeverity.error
      );
    }
  };

  return {
    onInviteUser,
    isInvitingUser,
  };
};

export default useInviteUserActions;
